import { css } from '@onbeam/business-styled-system/css';
import { text } from '@onbeam/business-styled-system/patterns';
import { Link } from '@onbeam/business-ui';
import { Components } from 'react-markdown';

export const mdxComponents: Components = {
  // Paragraphs and inline elements
  p: ({ children }) => (
    <p
      className={text({
        style: 'body-md',
        whiteSpace: 'pre-wrap',
      })}
    >
      {children}
    </p>
  ),
  a: ({ children, href }) => (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      variant="blue"
      iconAlwaysVisible
    >
      {children}
    </Link>
  ),
  strong: ({ children }) => (
    <strong className={text({ fontWeight: 'bold' })}>{children}</strong>
  ),
  // Lists
  ul: ({ children }) => (
    <ul
      className={css({
        listStyleType: 'disc',
        listStylePosition: 'inside',
        '& ul': { listStyleType: 'circle', mb: '0', mt: '1', pl: '4' },
        '& ol': { mb: '0', mt: '1' },
      })}
    >
      {children}
    </ul>
  ),
  ol: ({ children }) => (
    <ol
      className={css({
        listStyleType: 'decimal',
        listStylePosition: 'inside',
        '& ol': { mb: '0', mt: '1' },
        '& ul': { listStyleType: 'circle', mb: '0', mt: '1', pl: '4' },
      })}
    >
      {children}
    </ol>
  ),
  li: ({ children }) => (
    <li className={text({ style: 'body-md' })}>{children}</li>
  ),
};
